export default __webpack_public_path__ + "static/media/logo.9df24aa1.svg";